import React from 'react';
import { Link } from 'react-router-dom';
import { Col } from 'react-bootstrap';

import CardRaw from 'v3/components/Card';
import Text from 'v3/components/Text';
import Button from 'v3/components/Button';
function NegotiationCard({ negotiation }) {
  return (
    <Col md={6}>
      <CardRaw
        header={
          <div style={{ overflow: 'hidden', minWidth: 0, flex: 1 }}>
            <Text
              type="body"
              color="dark"
              title={negotiation.name}
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                display: 'block',
              }}
            >
              {negotiation.name}
            </Text>
          </div>
        }
        HeaderRightComponent={
          <Link to={`/negociacoes-carga/${negotiation.id}`}>
            <Button className="py-2">
              <Text color="white" type="regular" weight="500">
                Detalhes
              </Text>
            </Button>
          </Link>
        }
      >
        <Col style={{ gap: '0.5rem', display: 'flex', flexDirection: 'column' }}>
          <Col className="p-0">
            <Text type="label" color="dark">
              Tomador
            </Text>
            <Text type="regular" color="gray" as="p" className="mt-1">
              {negotiation.person?.socialName || negotiation.person?.label || 'Não informado'}
            </Text>
          </Col>
          <Col className="p-0">
            <Text type="label" color="dark">
              Centro de Custo
            </Text>
            <Text type="regular" color="gray" as="p" className="mt-1">
              {negotiation.costCenter?.name || 'Não informado'}
            </Text>
          </Col>
        </Col>
      </CardRaw>
    </Col>
  );
}

export default NegotiationCard;
